import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//排课管理系统相关API
const timetableManageAdultEducation = {
    //通用
    common: {
        //课表基础参数
        baseParam: config => createAPI('/timetableManageAdultEducation/common/baseParam', 'post', config),
        //当前学期相关信息
        semesterInfo: config => createAPI('/timetableManageAdultEducation/common/semesterInfo', 'post', config),
        //周次下拉框
        weekCombo: config => createAPI('/timetableManageAdultEducation/common/weekCombo', 'post', config),
        //获取单周具体日期
        weekdayDate: config => createAPI('/timetableManageAdultEducation/common/weekdayDate', 'post', config),
        //查询班级树
        queryClassTree: config => createAPI('/timetableManageAdultEducation/common/queryClassTree', 'post', config),
        //查询用户排课权限
        queryUserAuth: config => createAPI('/timetableManageAdultEducation/common/queryUserAuth', 'post', config),
        //根据排课权限查询班级树
        queryClassTreeByAuth: config => createAPI('/timetableManageAdultEducation/common/queryClassTreeByAuth', 'post', config),
    },

    //教师排课权限设置
    teaAuthConfig: {
        //初始化页面下拉框数据
        initCombo: config => createAPI('/timetableManageAdultEducation/rule/teaAuthConfig/initCombo', 'post', config),
        //查询教师权限列表
        queList: config => createAPI('/timetableManageAdultEducation/rule/teaAuthConfig/queList', 'post', config),
        //保存教师权限
        save: config => createAPI('/timetableManageAdultEducation/rule/teaAuthConfig/save', 'post', config),
        //删除教师权限
        del: config => createAPI('/timetableManageAdultEducation/rule/teaAuthConfig/del', 'post', config),
    },

    //排课解锁
    unlock: {
        //查询排课锁定列表
        queLockList: config => createAPI('/timetableManageAdultEducation/unlock/queLockList', 'post', config),
        //解锁
        unlock: config => createAPI('/timetableManageAdultEducation/unlock/unlock', 'post', config),
    },

    //自定义课程
    customCourse: {
        //查询自定义课程列表
        list: config => createAPI('/timetableManageAdultEducation/customCourse/list', 'post', config),
        //初始化下拉框
        initCombo: config => createAPI('/timetableManageAdultEducation/customCourse/initCombo', 'post', config),
        //保存
        save: config => createAPI('/timetableManageAdultEducation/customCourse/save', 'post', config),
        //删除
        del: config => createAPI('/timetableManageAdultEducation/customCourse/del', 'post', config),
    },

    //学生设置
    stuSetting: {
        //初始化下拉框
        initCombo: config => createAPI('/timetableManageAdultEducation/stuSetting/initCombo', 'post', config),
        //读取课程下拉框数据
        loadCourseCombo: config => createAPI('/timetableManageAdultEducation/stuSetting/loadCourseCombo', 'post', config),
        //读取学生名单列表
        list: config => createAPI('/timetableManageAdultEducation/stuSetting/list', 'post', config),
        //读取学生树
        queryStuTree: config => createAPI('/timetableManageAdultEducation/stuSetting/queryStuTree', 'post', config),
        //添加学生
        add: config => createAPI('/timetableManageAdultEducation/stuSetting/add', 'post', config),
        //删除学生
        del: config => createAPI('/timetableManageAdultEducation/stuSetting/del', 'post', config),
    },

    //排课
    arrange: {
        //查询学年学期列表
        queSemesterList: config => createAPI('/timetableManageAdultEducation/arrange/queSemesterList', 'post', config),
        //初始化页面下拉框数据
        initCombo: config => createAPI('/timetableManageAdultEducation/arrange/initCombo', 'post', config),
        //初始化空白课表
        initTimetable: config => createAPI('/timetableManageAdultEducation/arrange/initTimetable', 'post', config),
        //读取自动排课下拉框数据
        initCombo4Auto: config => createAPI('/timetableManageAdultEducation/arrange/initCombo4Auto', 'post', config),
        //读取自动排课系部下拉框数据
        loadDeptCombo4Auto: config => createAPI('/timetableManageAdultEducation/arrange/loadDeptCombo4Auto', 'post', config),
        //读取自动排课年级下拉框数据
        loadGradeCombo4Auto: config => createAPI('/timetableManageAdultEducation/arrange/loadGradeCombo4Auto', 'post', config),
        //读取自动排课专业下拉框数据
        loadMajorCombo4Auto: config => createAPI('/timetableManageAdultEducation/arrange/loadMajorCombo4Auto', 'post', config),
        //读取自动排课班级下拉框数据
        loadClassCombo4Auto: config => createAPI('/timetableManageAdultEducation/arrange/loadClassCombo4Auto', 'post', config),
        //自动排课
        autoCourseArrange: config => createAPI('/timetableManageAdultEducation/arrange/autoCourseArrange', 'post', config),
        //读取排课进度
        loadProgress: config => createAPI('/timetableManageAdultEducation/arrange/loadProgress', 'post', config),
        //读取删除课表系部下拉框数据
        loadDeptCombo4Del: config => createAPI('/timetableManageAdultEducation/arrange/loadDeptCombo4Del', 'post', config),
        //读取删除课表年级下拉框数据
        loadGradeCombo4Del: config => createAPI('/timetableManageAdultEducation/arrange/loadGradeCombo4Del', 'post', config),
        //读取删除课表专业下拉框数据
        loadMajorCombo4Del: config => createAPI('/timetableManageAdultEducation/arrange/loadMajorCombo4Del', 'post', config),
        //读取删除课表班级下拉框数据
        loadClassCombo4Del: config => createAPI('/timetableManageAdultEducation/arrange/loadClassCombo4Del', 'post', config),
        //初始化批量排课页面下拉框数据
        initCombo4Batch: config => createAPI('/timetableManageAdultEducation/arrange/initCombo4Batch', 'post', config),
        //读取批量排课课程下拉框数据
        loadCourseCombo4Batch: config => createAPI('/timetableManageAdultEducation/arrange/loadCourseCombo4Batch', 'post', config),
        //读取批量排课系部下拉框数据
        loadDeptCombo4Batch: config => createAPI('/timetableManageAdultEducation/arrange/loadDeptCombo4Batch', 'post', config),
        //读取批量排课年级下拉框数据
        loadGradeCombo4Batch: config => createAPI('/timetableManageAdultEducation/arrange/loadGradeCombo4Batch', 'post', config),
        //读取批量排课专业下拉框数据
        loadMajorCombo4Batch: config => createAPI('/timetableManageAdultEducation/arrange/loadMajorCombo4Batch', 'post', config),
        //读取批量排课班级下拉框数据
        loadClassCombo4Batch: config => createAPI('/timetableManageAdultEducation/arrange/loadClassCombo4Batch', 'post', config),
        //查询批量排课班级的排课情况
        queryCourseArrange4Batch: config => createAPI('/timetableManageAdultEducation/arrange/queryCourseArrange4Batch', 'post', config),
        //保存批量排课信息
        saveCourseArrange4Batch: config => createAPI('/timetableManageAdultEducation/arrange/saveCourseArrange4Batch', 'post', config),
        //删除课表
        delTimetable: config => createAPI('/timetableManageAdultEducation/arrange/delTimetable', 'post', config),
        //检查排课锁定状态
        verifyLockState: config => createAPI('/timetableManageAdultEducation/arrange/verifyLockState', 'post', config),
        //处理排课锁定状态
        handleLockState: config => createAPI('/timetableManageAdultEducation/arrange/handleLockState', 'post', config),
        //初始化教师场地已用信息
        initUsedOrderInfo: config => createAPI('/timetableManageAdultEducation/arrange/initUsedOrderInfo', 'post', config),
        //查询教师场地已用信息
        queUsedOrderInfo: config => createAPI('/timetableManageAdultEducation/arrange/queUsedOrderInfo', 'post', config),
        //查询班级课程安排信息
        queryClassCourseArrangeInfo: config => createAPI('/timetableManageAdultEducation/arrange/queryClassCourseArrangeInfo', 'post', config),
        //验证排课信息
        verifyCourseArrange: config => createAPI('/timetableManageAdultEducation/arrange/verifyCourseArrange', 'post', config),
        //保存班级课程表信息
        saveTimetable: config => createAPI('/timetableManageAdultEducation/arrange/saveTimetable', 'post', config),
        //查询周次使用情况（手动修改课程信息页面调用）
        queWeekUsedInfo: config => createAPI('/timetableManageAdultEducation/arrange/queWeekUsedInfo', 'post', config),
        //查询教师下拉框（手动修改课程信息页面调用）
        queTeaCombo4Change: config => createAPI('/timetableManageAdultEducation/arrange/queTeaCombo4Change', 'post', config),
        //查询场地下拉框（手动修改课程信息页面调用）
        queSiteCombo4Change: config => createAPI('/timetableManageAdultEducation/arrange/queSiteCombo4Change', 'post', config),
        //查询场地下拉框（未排课程指定教室调用）
        queSiteComboByType: config => createAPI('/timetableManageAdultEducation/arrange/queSiteComboByType', 'post', config),
        //查询备注信息
        queryRemark: config => createAPI('/timetableManageAdultEducation/arrange/queryRemark', 'post', config),
        //保存备注信息
        saveRemark: config => createAPI('/timetableManageAdultEducation/arrange/saveRemark', 'post', config),
        //查询学期排课时间列表
        querySemesterTimeList: config => createAPI('/timetableManageAdultEducation/arrange/querySemesterTimeList', 'post', config),
        //更新排课时间信息
        updateTimeInfo: config => createAPI('/timetableManageAdultEducation/arrange/updateTimeInfo', 'post', config),
        //查询课表校验信息
        queryTimetableVerifyInfo: config => createAPI('/timetableManageAdultEducation/arrange/queryTimetableVerifyInfo', 'post', config),
        //导出课表校验信息
        exportTimetableVerifyInfo: config => createAPI('/timetableManageAdultEducation/arrange/exportTimetableVerifyInfo', 'post', config),
        //查询课程安排情况信息
        queryExecuteInfo: config => createAPI('/timetableManageAdultEducation/arrange/queryExecuteInfo', 'post', config),
        //导出课程安排情况信息
        exportExecuteInfo: config => createAPI('/timetableManageAdultEducation/arrange/exportExecuteInfo', 'post', config),
        //更新班级禁排信息
        updateClassForbidInfo: config => createAPI('/timetableManageAdultEducation/arrange/updateClassForbidInfo', 'post', config),
        //同步开课计划
        syncTeachingPlan: config => createAPI('/timetableManageAdultEducation/arrange/syncTeachingPlan', 'post', config),
        //检查是否正在进行初始化使用情况操作
        verifyInitUsedOrderState: config => createAPI('/timetableManageAdultEducation/arrange/verifyInitUsedOrderState', 'post', config),
        //处理调课信息
        handleCourseAdjustInfo: config => createAPI('/timetableManageAdultEducation/arrange/handleCourseAdjustInfo', 'post', config),
        //验证合班课程排课信息
        verifyMergeCourseArrange: config => createAPI('/timetableManageAdultEducation/arrange/verifyMergeCourseArrange', 'post', config),
        //导入
        executeImport: config => createAPI('/timetableManageAdultEducation/arrange/executeImport', 'post', config),
    },

    //查询
    query: {
        //查询教师课表
        tea: config => createAPI('/timetableManageAdultEducation/query/tea', 'post', config),
        //查询学生课表
        stu: config => createAPI('/timetableManageAdultEducation/query/stu', 'post', config),
        //查询班级课表
        class: config => createAPI('/timetableManageAdultEducation/query/class', 'post', config),
        //查询场地课表
        site: config => createAPI('/timetableManageAdultEducation/query/site', 'post', config),
        //查询课程课表
        course: config => createAPI('/timetableManageAdultEducation/query/course', 'post', config),

        queryStudent: config => createAPI('/timetableManageAdultEducation/query/queryStudent', 'post', config),
        stuSearch: config => createAPI('/timetableManageAdultEducation/query/stuSearch', 'post', config),
        gradeOption: config => createAPI('/timetableManageAdultEducation/query/gradeOption', 'post', config),
        deptOption: config => createAPI('/timetableManageAdultEducation/query/deptOption', 'post', config),
        majorOption: config => createAPI('/timetableManageAdultEducation/query/majorOption', 'post', config),
        classOption: config => createAPI('/timetableManageAdultEducation/query/classOption', 'post', config),
        stuOption: config => createAPI('/timetableManageAdultEducation/query/stuOption', 'post', config),
    },

    classTimetable: {
        exportFile: config => createAPI('/timetableManageAdultEducation/query/classTimetable/exportFile', 'post', config),
        printFile: config => createAPI('/timetableManageAdultEducation/query/classTimetable/printFile', 'post', config),
        exportAll: config => createAPI('/timetableManageAdultEducation/query/classTimetable/exportAll', 'post', config),
        initCombo: config => createAPI('/timetableManageAdultEducation/query/classTimetable/initCombo', 'post', config),
    },

    teaTimetable: {
        queryTea: config => createAPI('/timetableManageAdultEducation/query/teaTimetable/queryTea', 'post', config),
        initCombo: config => createAPI('/timetableManageAdultEducation/query/teaTimetable/initCombo', 'post', config),
        exportFile: config => createAPI('/timetableManageAdultEducation/query/teaTimetable/exportFile', 'post', config),
        printFile: config => createAPI('/timetableManageAdultEducation/query/teaTimetable/printFile', 'post', config),
        exportAll: config => createAPI('/timetableManageAdultEducation/query/teaTimetable/exportAll', 'post', config),
        loadCourse: config => createAPI('/timetableManageAdultEducation/query/teaTimetable/loadCourse', 'post', config),
        loadStuList: config => createAPI('/timetableManageAdultEducation/query/teaTimetable/loadStuList', 'post', config),
        exportStuList: config => createAPI('/timetableManageAdultEducation/query/teaTimetable/exportStuList', 'post', config),
        printStuList: config => createAPI('/timetableManageAdultEducation/query/teaTimetable/printStuList', 'post', config),
        teaCombo: config => createAPI('/timetableManageAdultEducation/query/teaTimetable/teaCombo', 'post', config),
        changeDept: config => createAPI('/timetableManageAdultEducation/query/teaTimetable/changeDept', 'post', config),
    },

    stuTimetable: {
        printFile: config => createAPI('/timetableManageAdultEducation/query/stuTimetable/printFile', 'post', config),
        exportFile: config => createAPI('/timetableManageAdultEducation/query/stuTimetable/exportFile', 'post', config),
    },

    siteTimetable: {
        queryTree: config => createAPI('/timetableManageAdultEducation/query/siteTimetable/queryTree', 'post', config),
        initCombo: config => createAPI('/timetableManageAdultEducation/query/siteTimetable/initCombo', 'post', config),
        exportFile: config => createAPI('/timetableManageAdultEducation/query/siteTimetable/exportFile', 'post', config),
        printFile: config => createAPI('/timetableManageAdultEducation/query/siteTimetable/printFile', 'post', config),
        exportAll: config => createAPI('/timetableManageAdultEducation/query/siteTimetable/exportAll', 'post', config),
        initComboExport: config => createAPI('/timetableManageAdultEducation/query/siteTimetable/initComboExport', 'post', config),
        changeSiteType: config => createAPI('/timetableManageAdultEducation/query/siteTimetable/changeSiteType', 'post', config),
    },

    courseTimetable: {
        queryCourse: config => createAPI('/timetableManageAdultEducation/query/courseTimetable/queryCourse', 'post', config),
        exportFile: config => createAPI('/timetableManageAdultEducation/query/courseTimetable/exportFile', 'post', config),
        printFile: config => createAPI('/timetableManageAdultEducation/query/courseTimetable/printFile', 'post', config),
        exportAll: config => createAPI('/timetableManageAdultEducation/query/courseTimetable/exportAll', 'post', config),
    },

    allClassTimetable: {
        queryList: config => createAPI('/timetableManageAdultEducation/query/allClassTimetable/queryList', 'post', config),
        loadAllClassTimetable: config => createAPI('/timetableManageAdultEducation/query/allClassTimetable/loadAllClassTimetable', 'post', config),
        exportFile: config => createAPI('/timetableManageAdultEducation/query/allClassTimetable/exportFile', 'post', config),
        print: config => createAPI('/timetableManageAdultEducation/query/allClassTimetable/print', 'post', config),
    },

    allTeacherTimetable: {
        queryList: config => createAPI('/timetableManageAdultEducation/query/allTeacherTimetable/queryList', 'post', config),
        loadAllTeaTimetable: config => createAPI('/timetableManageAdultEducation/query/allTeacherTimetable/loadAllTeaTimetable', 'post', config),
        exportFile: config => createAPI('/timetableManageAdultEducation/query/allTeacherTimetable/exportFile', 'post', config),
        print: config => createAPI('/timetableManageAdultEducation/query/allTeacherTimetable/print', 'post', config),
    },

    onlineTimetable: {
        initData: config => createAPI('/timetableManageAdultEducation/query/onlineTimetable/initData', 'post', config),
        loadWeekNum: config => createAPI('/timetableManageAdultEducation/query/onlineTimetable/loadWeekNum', 'post', config),
        loadTimetable: config => createAPI('/timetableManageAdultEducation/query/onlineTimetable/loadTimetable', 'post', config),
        loadSemester: config => createAPI('/timetableManageAdultEducation/query/onlineTimetable/loadSemester', 'post', config),
        queryWeekdayDate: config => createAPI('/timetableManageAdultEducation/query/onlineTimetable/queryWeekdayDate', 'post', config),
    },

    courseQuery: {
        initCombo: config => createAPI('/timetableManageAdultEducation/query/courseQuery/initCombo', 'post', config),
        queryList: config => createAPI('/timetableManageAdultEducation/query/courseQuery/queryList', 'post', config),
        // 文档管理API
        saveDoc: config => createAPI('/timetableManageAdultEducation/query/courseQuery/saveDoc', 'post', config),
        queryOneDoc: config => createAPI('/timetableManageAdultEducation/query/courseQuery/queryOneDoc', 'get', config),
        queryAllDoc: config => createAPI('/timetableManageAdultEducation/query/courseQuery/queryAllDoc', 'get', config),
        deleteDocById: config => createAPI('/timetableManageAdultEducation/query/courseQuery/deleteDocById', 'get', config),
        saveDocRec: config => createAPI('/timetableManageAdultEducation/query/courseQuery/saveDocRec', 'post', config),
        deleteDocFile: config => createAPI('/timetableManageAdultEducation/query/courseQuery/deleteDocFile', 'get', config),
        queryDocFileById: config => createAPI('/timetableManageAdultEducation/query/courseQuery/queryDocFileById', 'get', config),
    }
};

export default timetableManageAdultEducation;



// WEBPACK FOOTER //
// ./src/api/modules/timetableManageAdultEducation.js